import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import './index.scss';
import { toggleModal } from '../../../../app/reducer';
import { Translate } from 'react-redux-i18n';
import Modal from '../../../../common/securities-firms';

class groupButton extends React.Component {
  div = document.createElement('div');

  componentDidMount() {
    document.body.appendChild(this.div);
  }

  componentWillUnmount() {
    document.body.removeChild(this.div);
  }

  handleOnclick = () => {
    const { toggleModal } = this.props;
    toggleModal(true);
  };

  handleBuyClick = () => {
    const { code } = this.props;
    window.parent.postMessage(
      {
        action: 'BUY',
        data: {
          ticker: code,
        },
      },
      '*',
    );
  };

  handleSellClick = () => {
    const { code } = this.props;
    window.parent.postMessage(
      {
        action: 'SELL',
        data: {
          ticker: code,
        },
      },
      '*',
    );
  };

  render() {
    return (
      <div className="group-button d-flex align-items-center justify-content-between my-other-other-step">
        {ReactDOM.createPortal(<Modal />, this.div)}
        <div className="group-button--buy mb-10" onClick={this.handleBuyClick}>
          <Translate value={`snapShot.groupButton.buy`} />
        </div>
        <div className="group-button--sell" onClick={this.handleSellClick}>
          <Translate value={`snapShot.groupButton.sell`} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: status => dispatch(toggleModal(status)),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(groupButton);
